export default {
	riskManagement: 'Risk management',
	tabs: {
		riskManagement: 'Risk management',
		riskSettings: 'Risk settings',
		threats: 'Threats',
		vulnerabilities: 'Vulnerabilities',
	},
	code: 'Code',
	name: 'Name',
	probability: 'Probability',
	impact: 'Impact',
	score: {
		label: 'Risk score',
		veryLow: 'Very low',
		low: 'Low',
		medium: 'Medium',
		high: 'High',
		veryHigh: 'Very high',
	},
	riskMatrix: 'Risk matrix',
	residualRiskScore: 'Residual risk score',
	cia: 'CIA',
	riskTreatment: 'Risk treatment',
	dueDate: 'Due date',
	description: 'Description',
	info: 'Info',
	risk: 'Risk | Risks | Risks',
	vulnerability: 'Vulnerability | Vulnerabilities',
	threat: 'Threat | Threats',
	mitigationMeasure: 'Mitigation measure | Mitigation measures',
	impactedAsset: 'Impacted asset | Impacted assets',
	filterAsset: 'Click to head to assets page',
	summary: 'Summary',
	category: 'Category | Categories',
	impactArea: 'Impact area',
	physicalDamage: 'Physical damage',
	lastReview: 'Last review',
	catalog: 'Catalog | Catalogs',
	user: 'User',
	riskDecision: 'Risk decision | Risk decisions',
	decision: 'Decision',
	date: 'Date',
	asset: 'Asset | Assets',
	assetAssociation: 'Asset association | Asset associations',
	responsible: 'Responsible | Responsibles',
	price: 'Price',
	priority: 'Priority',
	measuresImplemented: 'Measures implemented',
	colors: 'Colors',
	acceptable: 'Acceptable risk level',
	acceptableAchieved: 'Risk residual is under accepted risk score',
	acceptableAchievedEvent: 'Residual risk level achieved, reevaluate risk treatment.',
	treatment: {
		unscored: 'Unscored',
		preserve: 'Preserve',
		share: 'Share',
		reduce: 'Reduce',
		avoid: 'Avoid',
		exclude: 'Exclude',
	},
	residual: 'Residual',
	custom: 'Custom',
	riskDescription: 'Risk description',
	mitigation: {
		willNotImplement: 'Method will not be implemented',
		addConnections: 'Connect business process with module or raise security need',
		filter: 'Click to head to methods page',
		active: 'Active measures',
		total: 'Total number',
		assetModuleRemoved: 'Module connection with asset has been removed',
	},
	overview: {
		label: 'Overview of risks',
		approaching: 'Approaching due dates',
		criticalAssets: 'Critical assets',
		criticalMethods: 'Critical methods',
		highRiskScore: 'High residual risk score',
		importantChanges: 'Important changes',
		total: 'Total risks',
		overAcceptable: 'Over acceptable risk score',
		unscored: 'Unscored risks',
		overDeadline: 'Over deadline',
		residualAchieved: 'Residual achieved',
		underAcceptable: 'Under acceptable risk score',
		lastReview: 'Last review over a year',
		openInstance: 'Open instance risk management',
		methodsText: 'Implemented methods/All methods',
		responsibleDeadlines: 'Deadlines by responsible',
	},
	count: 'Connected risks',
	addingDisabled: 'Before adding new entities you must activate a catalog!',
	manualChange: 'Acceptable risk level has been changed manually',
	evaluateManually: 'Evaluate manually',
	resetToAuto: 'Reset to automatic calculation',
	manualResidualTag: 'Manual',
	addNewMeta: 'Add new risk connection',
	default: 'Main connection',
	connection: 'Risk connection | Connections',
	editConnection: 'Edit connections',
	objectConnection: 'Asset based connections',
	confirmDelete: 'Are you sure you want to delete this? Deleting the last risk connection deletes the whole risk.',
}
